var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAdd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 34 34"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 16,
  stroke: "#fff",
  strokeDasharray: "4 6",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#00CDF6",
  d: "M22.833 17.834h-5v5h-1.667v-5h-5v-1.667h5v-5h1.667v5h5v1.666z"
})), ">");
export default SvgAdd;